import { FC } from 'react';

import { Button } from '@portal/common/components';
import { ButtonProps } from '@portal/common/components/Button';

import _ from '../../locale';
import { useDataExplorerLayout } from '../DataExplorer/context';

const FiltersResetBtn: FC<ButtonProps> = ({ ...props }) => {
    const { isCompact } = useDataExplorerLayout();
    const size = isCompact ? 'xs' : 'md';

    return (
        <Button size={size} {...props}>
            {_('chart_reset_button_label')}
        </Button>
    );
};

export default FiltersResetBtn;
